<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-button">
      <Button
        v-if="isValid(value)"
        tag="a"
        type="secondary"
        size="tiny"
        :href="getHref(value)"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <SearchHighlightedText
          :text="getLabelOrURL(value)"
          :search-term="searchTerm"
        />
      </Button>
      <Button v-else tag="a" type="secondary" size="tiny" disabled>
        <SearchHighlightedText
          :text="getLabelOrURL(value)"
          :search-term="searchTerm"
        />
      </Button>
    </div>
  </div>
</template>

<script>
import linkURLField from '@baserow/modules/database/mixins/linkURLField'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldButton',
  components: { SearchHighlightedText },
  mixins: [linkURLField],
  props: {
    value: {
      type: Object,
      default: null,
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
